import { render, staticRenderFns } from "./ui-video.vue?vue&type=template&id=97808bc8&scoped=true&"
import script from "./ui-video.vue?vue&type=script&lang=js&"
export * from "./ui-video.vue?vue&type=script&lang=js&"
import style0 from "./ui-video.vue?vue&type=style&index=0&id=97808bc8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97808bc8",
  null
  
)

export default component.exports